// Group a slab's hex chips into the plain-English color families shoppers filter by.
export const FAMILIES = [
  ["Beige", "#e3d5b8"],
  ["Black", "#141414"],
  ["Blue", "#1668d8"],
  ["Brown", "#8a5a3c"],
  ["Gold", "#d9a419"],
  ["Grey", "#9a9a9a"],
  ["Green", "#12a355"],
  ["Red", "#e02424"],
  ["White", "#ffffff"],
];

const hsl = (hex) => {
  const clean = (hex || "").replace("#", "").trim();
  if (clean.length !== 3 && clean.length !== 6) return null;
  const full =
    clean.length === 3
      ? clean
          .split("")
          .map((c) => c + c)
          .join("")
      : clean;
  const r = parseInt(full.slice(0, 2), 16) / 255;
  const g = parseInt(full.slice(2, 4), 16) / 255;
  const b = parseInt(full.slice(4, 6), 16) / 255;
  if ([r, g, b].some((v) => Number.isNaN(v))) return null;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  const d = max - min;
  const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  let h = 0;
  if (d !== 0) {
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h = (h * 60 + 360) % 360;
  }
  return { h, s: s * 100, l: l * 100 };
};

export const colorFamily = (hex) => {
  const c = hsl(hex);
  if (!c) return "";
  if (c.l <= 14) return "Black";
  if (c.l >= 93 && c.s <= 12) return "White";
  if (c.s <= 12) return "Grey";
  if (c.h < 16 || c.h >= 340) return "Red";
  if (c.h < 45) {
    if (c.l >= 72 && c.s <= 55) return "Beige";
    return c.l >= 45 && c.s >= 55 ? "Gold" : "Brown";
  }
  if (c.h < 70) return c.l >= 80 ? "Beige" : "Gold";
  if (c.h < 165) return "Green";
  if (c.h < 265) return "Blue";
  return "Red";
};

// The families one piece of stock belongs to. Each color field may list several
// comma-separated colors, and every one contributes its family.
export const familiesOf = (item) =>
  Array.from(
    new Set(
      [item.primary_color, item.accent_color]
        .flatMap((v) => String(v || "").split(","))
        .map((c) => colorFamily(c.trim()))
        .filter(Boolean),
    ),
  );
